import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__content mb-sm" }
const _hoisted_2 = { class: "d-flex gap-sm" }
const _hoisted_3 = {
  class: "",
  style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "popup__controls" }
const _hoisted_6 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    title: _ctx.$t('labels.invite_url'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("a", {
                href: _ctx.url,
                target: "_blank"
              }, [
                _createElementVNode("small", null, _toDisplayString(_ctx.url), 1)
              ], 8, _hoisted_4)
            ]),
            _createVNode(_component_copy_button, { value: _ctx.url }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hide())),
            type: "button",
            class: "btn btn--accept"
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('button.ok')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}